import { useCallback } from 'react';

import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const usePostLoginRedirectHref = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.postLoginRedirectHref);
};

export const useSendClearPostLoginRedirectHref = () => {
  const { authMachineRef } = useEssentialMachines();

  return useCallback(() => {
    authMachineRef.send({ type: 'CLEAR_POST_LOGIN_REDIRECT_HREF' });
  }, [authMachineRef]);
};
